<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';

  import { getNotificationsContext } from '@client/components/notifications';

  import { GroupName } from '@client/pages/manage/groups/edit/group-name';

  import { GroupsService } from '@client/services/groups';

  import { generateUniqueRulename } from '@client/utils/rulenames';

  import { GeneralCloneForm } from '../index.js';

  export let nextDisabled = true;
  export let onExecute = null;
  export let onRollback = null;
  export let step = { data: {} };

  const { addNotification } = getNotificationsContext();

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  let groupForValidation = { groupname: '' };
  let groupNameInvalid = false;

  const getGroups = async () => {
    const groups = await GroupsService.getAll();
    return groups.map((group) => ({
      label: group.groupname,
      value: group.groupname,
      ...group
    }));
  };

  const onCloneGroup = async (group, newRulename) => {
    const groupname = groupForValidation.groupname || generateUniqueRulename(group.groupname);

    const payload = {
      ...group,
      _id: null,
      _newObject: true,
      groupname
    };

    const response = await GroupsService.createGroup(payload);

    if (response !== 'Empty' && response?.status >= 400) {
      notify($format('label.FAILURE.GROUP_CLONE', { values: { group: group.groupname } }), 'error');
      throw new Error($format('label.FAILURE.GROUP_CLONE'));
    }

    notify($format('label.SUCCESS.GROUP_CLONE', { values: { group: group.groupname } }));

    step.data = {
      id: groupname,
      originalId: group.groupname
    };
  };

  const rollbackCloneGroup = async () => {
    if (!step.data?.id) {
      return; // Nothing to rollback
    }

    try {
      // Get the cloned group
      const allGroups = await GroupsService.getAll();
      const group = allGroups.find((g) => g.groupname === step.data.id);

      if (group) {
        await GroupsService.deleteGroup(group);
      }
    } catch (error) {
      console.error('Failed to rollback group clone:', error);
    }
  };
</script>

<GeneralCloneForm
  bind:nextDisabled
  bind:step
  {onExecute}
  {onRollback}
  rollbackFunction={rollbackCloneGroup}
  getFunction={getGroups}
  cloneFunction={onCloneGroup}
  bind:inputInvalid={groupNameInvalid}
>
  <GroupName slot="input" bind:group={groupForValidation} bind:invalid={groupNameInvalid} optional />
</GeneralCloneForm>
